import React, { PropTypes, Component } from 'react';
import { NavLink } from 'fluxible-router';
import { connectToStores } from 'fluxible/addons';
import Facebook from './Facebook';
import { checkUserRegister, signin, UserLogout } from '../actions/LoginServiceCreator';
import { loadprofileentity } from '../actions/WebsiteLoadCreator';
import { setpopularsearch } from '../actions/HomeLoadCreator';
var cookie = require('react-cookie');

class Nav extends Component {
  static contextTypes = {
    executeAction: React.PropTypes.func
  }
  static propTypes = {
    logindata: PropTypes.object.isRequired
  }
  componentDidMount() {
    var response = {};
    response.id = cookie.load('id', true);
    this.context.executeAction(loadprofileentity, response);
    if (this.props.selected !== 'home') {
    }
  }
  setProfilePic() {

    if (this.props.profiledata.profile.length != 0) {
      if (cookie.load('logged_in', true) === "1") {
        if (this.props.profiledata.profile[0].profileimage != null) {
          return 'https://k-s3bkp.s3.eu-west-2.amazonaws.com/folink/UserProfile/' + cookie.load('id', true) + '/' + cookie.load('id', true) + '_profile.png';
        } else {
          return 'http://graph.facebook.com/undefined/picture';
        }
      } else if (cookie.load('logged_in', true) === "2") {
        return 'http://graph.facebook.com/' + cookie.load('id', true) + '/picture';
      }
    }
  }
  render() {
    var headerlogo;
    return (
      <div className="navbar navbar-inverse navbar-fixed-top" id="header" role="navigation">
        <div className="navbar-inner">
          <div className="container-fluid navbar-container">
            <div className="row-fluid">
              { (this.props.selected === 'home' || this.props.selected === 'login' || this.props.selected === 'signup') ? (
                <div className="col-md-6 logo-part" style={ { "padding": "5px" } }>
                  <button type="button" className="btn btn-navbar" style={ { display: 'none' } }>
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                  </button>
                  <a className="brand" href="/">
                    <img className="logo-img" src="https://folink.s3.eu-west-2.amazonaws.com/icons/krowd-logo-2.png" style={ { "width": "25%", "padding": "2%" } } />
                  </a>
                </div>
              ) : (
                <div className="col-md-6 logo left-nav" style={ { "background-color": "#690606" } }>
                  <span style={ { "float": "left", "width": "100%", "height": "40px", "position": "relative" } }>
                    <button type="button" className="btn btn-navbar" style={ { display: 'none' } }>
                      <span className="icon-bar"></span>
                      <span className="icon-bar"></span>
                      <span className="icon-bar"></span>
                    </button>
                    <a className="brand" href="/">
                      <img src="https://folink.s3.eu-west-2.amazonaws.com/icons/Asset-logo.png" style={ { "width": "25%", "float": "left", "margin-top": "0vh" } } />
                    </a>
                    <span className="search-box nav-search nav-search-box" style={ { "position": "relative", "margin-top": "0vh", "padding": "0vh !important", "float": "left" } }>
                    </span>
                  </span>
                </div>) }
              <div className="col-md-6 nav-menus clearfix" style={ { "width": "auto", "float": "right" } }>
                <div className="nav-left">
                </div>
                <div className="nav-right">
                  <ul className="nav" style={ { "padding": "1em", "padding-bottom": "0em", "margin": "0" } }>
                    { /*<li className="enter-link"><a className="login_menu login-link" href="/userinput" style={{"padding-right": '1em'}}>Existing User</a></li>
                    <li className="enter-link"><a className="login_menu login-link" href="/entertainer" style={{"padding-right": '1em'}}>New User</a></li> */}

                    <li>
                      { /*this.props.logindata.logged_in === 0 && (
                        <div id="login-popup" className="dropdown" style={ { "padding-top": "10px" } }>
                          <span className="login_menu login-link" onClick={ this.goToLogin.bind(this) }> Login/Signup </span>
                        </div>
                      ) */}
                      { this.props.logindata.logged_in === 1 && (
                        <div className="clearfix">
                          <div className="notify-div">
                            <a href='/' className="notifications">
                              <i className="notifications-img"></i>
                            </a>
                          </div>
                          <div id="login-popup" className="dropdown" style={ { 'float': 'left' } }>
                            <NavLink href="login" className="dropdown-toggle login_menu">
                              <a className="profile-pic">
                                <img className="profile-img" src={ this.setProfilePic() } />
                              </a>
                            </NavLink>
                            <ul className="dropdown-menu" id="menu1">
                              <li><a style={ { cursor: 'pointer' } } onClick={ this.goToProfile.bind(this) }>My profile</a></li>
                              <li>
                                <NavLink href="#" onClick={ this.logoutUser.bind(this) } style={ { cursor: 'pointer' } }>Logout</NavLink>
                              </li>
                            </ul>
                          </div>
                        </div>
                        ) }
                      { this.props.logindata.logged_in === 2 && (
                        <div className="clearfix">
                          <div className="notify-div">
                            <a href='/' className="notifications">
                              <i className="notifications-img"></i>
                            </a>
                          </div>
                          <div id="login-popup" className="dropdown" style={ { 'float': 'left' } }>
                            <NavLink href="login" className="dropdown-toggle login_menu">
                              <a className="profile-pic">
                                <img className="profile-img" src={ this.setProfilePic() } />
                              </a>
                            </NavLink>
                            <ul className="dropdown-menu" id="menu1">
                              <li><a onClick={ this.goToProfile.bind(this) } style={ { cursor: 'pointer' } }>My profile</a></li>
                              <li>
                                <NavLink href="#" onClick={ this.logoutUser.bind(this) } style={ { cursor: 'pointer' } }>Logout</NavLink>
                              </li>
                            </ul>
                          </div>
                        </div>
                        ) }
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      );
  }

  validatelogin(response) {
    response.sessionid = cookie.load('sid');
    response.ip = cookie.load('ip');
    response.is_fb_login = 1;
    response.is_gmail_login = 0;
    response.is_twitter_login = 0;
    response.is_linkedin_login = 0;
    $(".whirly-loader").css('visibility', 'visible');
    this.context.executeAction(checkUserRegister, response);
  }
  logoutUser() {
    var data = {
      sid: cookie.load('sid'),
      id: ''
    };
    this.context.executeAction(UserLogout, data);
  }
  goToProfile() {
    window.location.href = '/profile';
  }
  goToLogin() {
    if (this.props.selected !== 'login' || this.props.selected !== 'signup') {
      var date = new Date();
      var days = days || 365;
      date.setTime(+date + (days * 86400000));
      cookie.save('referrer', this.props.currentNavigate.toString(), {
        expires: date,
        httpOnly: false,
        path: '/'
      });
    }
    window.location.href = '/login';
  }
}

Nav.defaultProps = {
  selected: 'home',
  links: {},
  logindata: {},
  profiledata: {}
};

Nav = connectToStores(Nav, ['LoginStore', 'UserProfileStore'], (stores, props) => {
  return {
    logindata: stores.LoginStore.get(),
    profiledata: stores.UserProfileStore.get()
  };

});
export default Nav;



// WEBPACK FOOTER //
// ./src/components/Nav.js